import OffersV2Shelf from './OffersV2Shelf';

export default OffersV2Shelf;
